import { render, staticRenderFns } from "./SuggestedCartMenuItem.vue?vue&type=template&id=7ee3ea5c&scoped=true"
import script from "./SuggestedCartMenuItem.vue?vue&type=script&lang=js"
export * from "./SuggestedCartMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee3ea5c",
  null
  
)

export default component.exports